import apiClient from "./apiClient";
import { ENDPOINTS } from "./endpoints";
import { useQuery } from "@tanstack/react-query";
import queryKeys from "../queryKeys";

export const checkHealth = async () => {
    return apiClient.get(ENDPOINTS.health);
};

export const checkNotificationHealth = async () => {
    return apiClient.get(ENDPOINTS.notificationHealth);
};

export const useHealthCheck = (options = {}) => {
    return useQuery({
        queryKey: queryKeys.health(),
        queryFn: checkHealth,
        refetchInterval: 5 * 60 * 1000,
        retry: 2,
        retryDelay: (attempt) => 1000 * 2 ** (attempt + 1),
        ...options,
    });
};

export const useNotificationHealthCheck = (options = {}) => {
    return useQuery({
        queryKey: queryKeys.notificationHealth(),
        queryFn: checkNotificationHealth,
        refetchInterval: 5 * 60 * 1000,
        retry: 2,
        retryDelay: 1000,
        ...options,
    });
};
